export const SSEMSG = "SSEMSG";
export const getSSEmsg = (data) => {
    return {
        type: SSEMSG,
        payload: data
    }
}